import React, { Component } from 'react';
import Article from './ui/Article.js'
import Section from './ui/Section.js'
import PackageTopic from './PackageTopic.js'
import ReactMarkdown from 'react-markdown';

class Package extends Component {

    anyFilePassesTest(predicate) {
        var files = this.props.descriptor.files;
        for (var i = files.length - 1; i >= 0; i--) {
            var file = files[i];
            if (predicate(file)) {
                return true;
            }
        }
        return false;
    }

    render() {
        return (
            <Article kind="Package" title={this.props.descriptor.fullName} subtitle={this.props.descriptor.summary}>
                {this.props.descriptor.overview &&
                    <Section title="Overview">
                        <ReactMarkdown source={this.props.descriptor.overview} />
                    </Section>
                }
                {this.props.descriptor.index &&
                    <Section title="Topics">
                        {this.props.descriptor.index.topics
                            .map((topic) => (
                                <PackageTopic title={topic.title} baseName={this.props.descriptor.fullName} itemNames={topic.items} />
                            ))}
                    </Section>
                }
            </Article>
        );
    }

}

export default Package;



// WEBPACK FOOTER //
// ./src/reference/Package.js